import { render, staticRenderFns } from "./OrderQuery.vue?vue&type=template&id=0b49fe12&"
import script from "./OrderQuery.vue?vue&type=script&lang=js&"
export * from "./OrderQuery.vue?vue&type=script&lang=js&"
import style0 from "./OrderQuery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports